"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COMPONENT_NAME = void 0;
var _classNameGenerator = require("../theming/classNameGenerator");
var COMPONENT_NAME = exports.COMPONENT_NAME = 'Dialog';
var CLASSNAME_DIALOG = (0, _classNameGenerator.generateComponentClassNames)({
  component: COMPONENT_NAME,
  children: ['Header', 'Title', 'Content', {
    component: 'Content',
    children: ['Text']
  }, 'Icon', 'Illustration', 'Actions', {
    component: 'Actions',
    children: ['Wrapper']
  }]
});
var _default = exports["default"] = CLASSNAME_DIALOG;